<template>
  <div>
    <ali-player
      :source="视频url"
      ref="player"
    ></ali-player>
    <button @click="play">播放</button>
    <button @click="pause">暂停</button>
    <button @click="replay">重播</button>
  </div>
</template>
<script>
// import VueAliplayer from 'vue-aliplayer'
export default {
    // components: {
    // 'ali-player': VueAliplayer
    // },
    methods: {
      play: function(){
        const player = this.$refs.player.instance
        player && player.play()
      },
      pause: function() {
        const player = this.$refs.player.instance
        player && player.pause()
      },
      replay: function() {
        const player = this.$refs.player.instance
        player && player.replay()
      }
    }
}
</script>


// WEBPACK FOOTER //
// src/view/show.vue